<script>
	import { axiosInstance } from './api/axiosInstance'
	import * as date from './utils/date'
	import * as store from './store'

	let selectedDate = {"month":new Date().getMonth()+1,"year":new Date().getFullYear()}
	let monthList = date.monthList()
	let yearList = date.yearList()

	let deals = []
	let filteredDeals = []
	let totals = {}

	let filterMeetingOK = false
	let filterContractOK = false
	let filterAllDates = false

	getDeals();

	function getDeals(){
		//reset filters
		filterContractOK = false
		filterMeetingOK = false

		let startDate = date.getFirstDayOfMonth(selectedDate.month, selectedDate.year)
		let endDate = date.getLastDayOfMonth(selectedDate.month, selectedDate.year)

		axiosInstance.get('ipa-deals-iad?meeting_completed_date[$gte]='+startDate+'&meeting_completed_date[$lte]='+endDate+'&$limit=100')
		.then(function(result){
			deals = result.data
			filteredDeals = filterDeals()
			totals = getTotals(filteredDeals)
		})
		.catch(function(err){
			if (err.message.indexOf("401") != -1){
				store.setValue('authenticated',false)
				store.setValue('accessToken',null)
			}
		})
		
	}

	function getAllDealsFromStart(){
		/*if we want all deals from the start, don't filter on date*/
		if(filterAllDates){
			axiosInstance.get('ipa-deals-iad?$limit=1000')
			.then(function(result){
				deals = result.data
				filteredDeals = filterDeals()
				totals = getTotals(filteredDeals)
			})
			.catch(function(err){
				if (err.message.indexOf("401") != -1){
					store.setValue('authenticated',false)
					store.setValue('accessToken',null)
				}
			})
		}
		/*else use classic method with filter*/
		else{
			getDeals()
		}
	}


	function calculateContractCommission(deal){
		if(deal.negociated_price_euro != null){
			return parseFloat((deal.negociated_price_euro - deal.negociated_net_price_euro)*deal.contract_signed_commission_pct)
		}
		return 0
	}

	function dealToDisplay(deal){
		if(filterMeetingOK && deal.meeting_completed != true)
			return false

		if(filterContractOK && deal.contract_signed != true)
			return false

		return true
	}

	function filterDeals(){
		filteredDeals = []
		deals.forEach(function(deal){
			if(dealToDisplay(deal))
				filteredDeals.push(deal)
		})

		totals = getTotals(filteredDeals)

		return filteredDeals
	}

	function getTotals(deals){
		let total = {'totalDeals':0, 'totalCommissions':0}
		deals.forEach(function(deal){
			total.totalDeals ++

			if (deal.meeting_completed)
				total.totalCommissions += deal.meeting_completed_commission_euro
		})

		return total
	}

	
	
</script>

<main>
	<h2>LEADS</h2>
<br>
	<div class="container">
		<div class="row">
			<div class="col-md-6">
				<label>Date:</label>
				<select bind:value={selectedDate.month} name="month" on:change="{getDeals}">
					{#each monthList as month}
						<option value={month}>
							{month}
						</option>
					{/each}

				</select>

				<select bind:value={selectedDate.year} name="year" on:change="{getDeals}">
					{#each yearList as year}
						<option value={year}>
							{year}
						</option>
					{/each}
				</select>

				<div id="all-dates-container" class="form-group">
						<label >
							<input type=checkbox bind:checked={filterAllDates} on:change="{getAllDealsFromStart}">
							Depuis le début
						</label>
				</div>

			</div>

			<div class="col-md-6 row">
				<div class="col-md-6 text-right">
					<label>Filtrer:</label>
				</div>
				<div class="col-md-6">
					<div class="form-group text-left">
						<label >
							<input type=checkbox bind:checked={filterMeetingOK} on:change="{filterDeals}">
							RDV effectué
						</label>
					</div>
					<div class="form-group text-left">
						<label >
							<input type=checkbox bind:checked={filterContractOK} on:change="{filterDeals}">
							Acte signé
						</label>
					</div>

				</div>
			</div>
		</div>

<br>

		<div id="total-container">
			<table>
				<thead>
					<tr><th>TOTAL</th><th>&nbsp;</th><th>&nbsp;</th><th>TOTAL COMMISSIONS RDV (€)</th></tr>
				</thead>
				<tbody>
				<tr><td>{totals.totalDeals}</td><td></td><td></td><td>{totals.totalCommissions}</td></tr>
				</tbody>
			</table>
		</div>

		<table class="table">
				<thead>
					<tr><th>Lead</th><th>RDV effectué</th><th>Date RDV</th><th>Commission RDV</th><th>Mandat signé</th><th>Date mandat</th><th>Acte authentique signé</th><th>Date acte authentique</th><th>Commission acte authentique</th> <th>Agent</th></tr>
				</thead>
				<tbody>
					{#each filteredDeals as deal}
						<tr><td>{deal.lead.reference}</td>
								<td>{deal.meeting_completed}</td>
								<td>{deal.meeting_completed_date}</td>

								<td>{deal.meeting_completed != null ?deal.meeting_completed_commission_euro : 0}</td>
								<td>{deal.intermediation_contract_signed}</td>
								<td>{deal.intermediation_contract_signed_date}</td>

								<td>{deal.contract_signed}</td>
								<td>{deal.contract_signed_date}</td>
								<td>{calculateContractCommission(deal)}</td>
								<td>{deal.partner_agent.first_name+' '+deal.partner_agent.last_name}</td>
						</tr>
					{/each}
				</tbody>
		</table>


		
	</div>
		
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

	#total-container {
		margin-bottom:30px;
	}

	#total-container table {
		margin: 0 auto;
	}

	#all-dates-container{
		margin: 0 auto;
		margin-top:15px;
	}
</style>